// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_ToggleRelacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /localidades/toggleRelacao
 *
 * Toggles a location-franchise relationship.
 */
import { registerContract } from './validate'

export interface Localidades_ToggleRelacaoInput {
type: string
localidade_id: number
franquia_id: number
}

registerContract('Localidades_ToggleRelacaoInput', {
  type:          { type: 'string',  required: true },
  localidade_id: { type: 'number',  required: true },
  franquia_id:   { type: 'number',  required: true },
})
